const FeeCollectionEnum = Object.freeze({
    DIRECT: 'DIRECT',
    FACILITATED_PLATFORM: 'FACILITATED_PLATFORM',
    FACILITATED_PROVIDER: 'FACILITATED_PROVIDER'
});

export default FeeCollectionEnum;
